// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"3705d202","80":"b03243b7","140":"3705d202","365":"8a961fc2","514":"3705d202","640":"7d68a283","664":"3705d202","729":"d27ffbee"}[chunkId] + ".chunk.css";
};